import React, { useEffect, useState, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Paper, Grid, Box, Button, Hidden } from '@mui/material';
import { makeStyles } from '@mui/styles';

import logo from 'assets/logo_horizontal.png';
import Welcome from './Welcome';
import ReadFor from './ReadFor';
import Form1 from './Form_1';
import Form2 from './Form_2';
import Form3 from './Form_3';
import Form4 from './Form_4';
import Form5 from './Form_5';
import Form6 from './Form_6';
import Form8 from './Form_8';
import Success from './success';
import { setCoverageAmount } from '../redux/actions/getFormActions';
import { Typography, colors, Stepper, styles } from '@leapeasy/ui-kit';
import { isCleanEmbedMode } from '../config/embedMode';
import { CustomStepperWrapper } from '../components/CustomWrapper';
const useStyles = makeStyles((theme) => ({
  logo: {
    width: 250,
    height: 80,
  },
}));

const steps = [
  {
    label: '1',
    title: 'Personal information',
  },
  {
    label: '2',
    title: 'About Your New Home',
  },
  {
    label: '3',
    title: 'Lease Detail',
  },
  {
    label: '4',
    title: 'Lease Detail 2',
  },
  {
    label: '5',
    title: 'Your Current Address',
  },
  {
    label: '6',
    title: 'Identity Information',
  },
  {
    label: '7',
    title: 'Review',
  },
];

const steps_without_title = [
  {
    label: '1',
    title: '',
  },
  {
    label: '2',
    title: '',
  },
  {
    label: '3',
    title: '',
  },
  {
    label: '4',
    title: '',
  },
  {
    label: '5',
    title: '',
  },
  {
    label: '6',
    title: '',
  },
  {
    label: '7',
    title: '',
  },
];

export default function ClaimForm() {
  const formData = useSelector((state) => state.formData);
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [coverageTypeError, setCoverageTypeError] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (formData.coverageAmount && formData.coverageAmount.autoEnroll && formData.data.isStudent) {
      setCoverageTypeError(formData.coverageAmount.autoEnroll);
    } else {
      setCoverageTypeError(false);
    }
  }, [formData.coverageAmount]);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleCoverageErrorBack = () => {
    dispatch(setCoverageAmount(null));
    setActiveStep(3);
  };

  return (
    <Box
      sx={{
        height: isCleanEmbedMode ? 'auto' : '100%',
        display: 'flex',
        alignItems: isCleanEmbedMode ? 'stretch' : 'flex-start',
        width: isCleanEmbedMode ? '100%' : '1440px',
        maxWidth: isCleanEmbedMode ? '100%' : '90%',
        margin: 'auto',
        px: isCleanEmbedMode ? { xs: 1.5, sm: 2, md: 3 } : 0,
        py: isCleanEmbedMode ? { xs: 1, sm: 2 } : 0,
      }}
    >
      <Grid
        container
        justifyContent={isCleanEmbedMode ? 'center' : 'space-between'}
        alignItems="stretch"
        sx={
          isCleanEmbedMode
            ? { width: '100%', maxWidth: '980px', margin: '0 auto' }
            : activeStep < 2
              ? { height: '70%', alignSelf: 'center' }
              : { marginTop: 6 }
        }
      >
        {!isCleanEmbedMode && (
          <Grid
            item
            md={5}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              maxHeight: '80vh',
            }}
          >
            <img src={logo} className={classes.logo} />

            <Box display="flex" flexDirection="column" sx={{ gap: '16px' }}>
              <Typography variant="h2" style={{ color: 'white', fontWeight: '700' }}>
                Welcome to <br />the Rent Guaranty Application!
              </Typography>

              <Typography variant="body1" style={{ color: 'white' }}>
                Get access to the apartments you’ve only dreamed of <br /> without prepaying rent or
                making your parents co-sign.
              </Typography>
            </Box>
          </Grid>
        )}

        {!isCleanEmbedMode && <Grid item md={0.5} />}

        <Grid item xs={12} md={isCleanEmbedMode ? 12 : 6.5} sx={{ my: isCleanEmbedMode ? 0 : 2 }}>
          <Paper
            sx={{
              borderRadius: '12px',
              padding: 2,
              display: 'flex',
              boxShadow: isCleanEmbedMode ? '0px 8px 24px rgba(16, 24, 40, 0.08)' : undefined,
              width: '100%',
              overflow: 'visible',
            }}
          >
            {activeStep >= 2 && (
              <>
                <Hidden smDown>
                  <Box
                    sx={{
                      background: colors.purple[100],
                      borderRadius: styles.borderRadius.small,
                      // padding: `${styles.spacing.space12}px ${styles.spacing.space1}px`,
                      padding: `${styles.spacing.space12}px ${0}px`,
                      flexGrow: 0,
                      flexShrink: 1,
                    }}
                  >
                    <Stepper
                      steps={steps}
                      activeStep={activeStep - 2}
                      labelAlignment="row"
                      stepAlignment="column"
                    />
                  </Box>
                </Hidden>
                <Hidden smUp>
                  <Box
                    sx={{
                      // background: colors.purple[100],
                      borderRadius: styles.borderRadius.small,
                      // padding: `${styles.spacing.space12}px ${styles.spacing.space1}px`,
                      // padding: `${styles.spacing.space12}px ${0}px`,
                      flexGrow: 0,
                      flexShrink: 1,
                    }}
                  >
                    <CustomStepperWrapper>
                    <Stepper
                      steps={steps_without_title}
                      activeStep={activeStep - 2}
                      labelAlignment="row"
                      stepAlignment="column"
                    />
                    </CustomStepperWrapper>
                  </Box>
                </Hidden>
              </>
            )}
            <Box
              display="flex"
              flexDirection="column"
              padding={{ xs: 0, sm: 4 }}
              gap="20px"
              sx={{ flexGrow: 1 }}
            >
              {activeStep < 2 && (
                <>
                  <Typography variant="h3" style={{ color: colors.purple[900], fontWeight: '500' }}>
                    Rent Guaranty Application
                  </Typography>

                  <Box sx={{ width: '100%', border: `1px solid ${colors.purple[200]}` }} />
                </>
              )}

              {true ? (
                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                  <Fragment>
                    {activeStep === 0 && <Welcome handleNext={handleNext} />}
                    {activeStep === 1 && (
                      <ReadFor handleNext={handleNext} handleBack={handleBack} />
                    )}
                    {activeStep === 2 && <Form1 handleNext={handleNext} handleBack={handleBack} />}
                    {activeStep === 3 && <Form2 handleNext={handleNext} handleBack={handleBack} />}
                    {activeStep === 4 && <Form3 handleNext={handleNext} handleBack={handleBack} />}
                    {activeStep === 5 && <Form4 handleNext={handleNext} handleBack={handleBack} />}
                    {activeStep === 6 && <Form5 handleNext={handleNext} handleBack={handleBack} />}
                    {activeStep === 7 && <Form6 handleNext={handleNext} handleBack={handleBack} />}
                    {activeStep === 8 && (
                      <Form8
                        handleNext={handleNext}
                        handleBack={handleBack}
                        handleStep={(value) => setActiveStep(value)}
                      />
                    )}
                    {activeStep === 9 && <Success />}
                  </Fragment>
                </Box>
              ) : (
                <Box sx={{ p: 2 }}>
                  <Grid container justifyContent="center">
                    <Typography variant="h6" color="primary" textAlign="center">
                      Please note, you have selected to apply for a partner community that offers a
                      monthly pay Guarantor Waiver Program.
                    </Typography>
                    <Typography variant="h6" color="primary" textAlign="center">
                      Based on the information you provided, you may qualify for this
                      application-free program.
                    </Typography>
                    <Typography variant="h6" color="primary" textAlign="center">
                      Rather than proceeding with a Rent Guaranty application, please contact the
                      community's leasing team for more information about the Guarantor Waiver
                      Program.
                    </Typography>
                  </Grid>
                  <Grid container justifyContent="center" sx={{ mt: 3 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleCoverageErrorBack()}
                    >
                      Back
                    </Button>
                  </Grid>
                </Box>
              )}
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
